import React from 'react'
import {Button, Checkbox, Grid} from "@mui/material"

import {useDispatch, useSelector} from "react-redux"
import {changePage, makeRegistration} from "../redux/actions"
import {UserModel} from '../models/UserModel'

import AppHeader from "../components/AppHeader"

const SingYourContractPage = () => {

    const dispatch = useDispatch()

    const curState = useSelector(state => state)

    const handleNextStep = (e) => {

        const user = UserModel.createFromState(curState)

        dispatch(makeRegistration({userObject: user}))
    }

    const lang = useSelector(state => state.lang)

    return (
        <Grid container spacing={2}
              style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '4px'}}>
            <AppHeader/>

            <Grid className="containerAlignBottom" container item spacing={2} xs={11}>
                <Grid style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}} item xs={12}>
                    <h1 className="secondH1Title">{lang.sign_your_new_contract}</h1>

                    <Grid
                        style={{marginTop: '10px'}}
                        container item spacing={2} md={6} xs={12}>
                        <Grid className="contact-item" item xs={12}>
                            <Checkbox
                                value="checkedA"
                                checked={true}
                                color="default"
                            />
                            <p>
                                {lang.agree_1}
                                <a href="https://kav2go.nl/terms-and-conditions">https://kav2go.nl/terms-and-conditions</a>
                            </p>
                        </Grid>
                        <Grid className="contact-item" md={6} item xs={12}>
                            <Checkbox
                                value="checkedA"
                                checked={true}
                                color="default"
                            />
                            <p>
                                {lang.agree_2}
                                <a
                                    target="_blank"
                                    href="https://kav2go.nl/house-rules">
                                    https://kav2go.nl/house-rules</a>
                            </p>
                        </Grid>
                        <Grid className="contact-item" item xs={12}>
                            <Checkbox
                                value="checkedA"
                                checked={true}
                                color="default"
                            />
                            <p>
                                {lang.agree_3}
                                <a
                                    target="_blank"
                                    href="https://kav2go.nl/customer-contract">
                                    https://kav2go.nl/customer-contract</a>
                            </p>
                        </Grid>
                        <Grid className="contact-item" item xs={12}>
                            <Checkbox
                                value="checkedA"
                                checked={true}
                                color="default"
                            />
                            <p>
                                {lang.agree_4}
                                <a target="_blank" href="https://kav2go.nl/procedure-description">
                                    https://kav2go.nl/procedure-description</a>
                            </p>
                        </Grid>
                    </Grid>

                </Grid>

                <Grid
                    style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'center'}}
                    item xs={12}>
                    <Button
                        className="main-button main-button-register"
                        style={{marginBottom: '20px'}}
                        data-disabled={false}
                        onClick={handleNextStep}
                        variant="contained">{lang.agree}</Button>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default SingYourContractPage